<template>
    <button
        class="image-bit poi-button"
        ref="image-bit"
        aria-hidden="true"
        :class="{ selected: selectedPoi && selectedPoi.includes(id) }"
        @click="setPoi"
        :style="{ width: imageData.width, top: imageData.top, left: imageData.left }"
    >
        <span class="rotate-control">
            <span class="custom">
                <span :class="imageData.path">{{ valueOverride }}</span>
            </span>
        </span>
    </button>
</template>

<script>
import { scrollTo } from "@/utils";
import { mapGetters } from "vuex";

export default {
    props: {
        id: {
            type: String,
            default() {
                return `image-bit-${this._uid}`;
            },
        },
        imageData: Object,
        valueOverride: String,
    },

    computed: {
        ...mapGetters({
            selectedPoi: "handbook/getPoi",
        }),
    },

    methods: {
        setPoi() {
            this.$store.commit("handbook/setPoi", "image:" + this.id);
        },
    },

    watch: {
        selectedPoi(value) {
            if (value === "poi:" + this.id) {
                scrollTo(this.$refs["image-bit"]);
                this.$refs["image-bit"].focus();
            }
        },
    },
};
</script>
